/**
 * CRM в браузере: /{ownerId}/crm/... — чтобы ссылку можно было отдать админам.
 * API по-прежнему /api/crm/:branchId/... (owner из JWT).
 */

const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
const OWNER_ID_RE = new RegExp(`^\\/(${UUID})\\/crm(?:\\/|$)`, 'i');

/** Из pathname достаёт UUID владельца, если это зона CRM. */
export function parseCrmOwnerIdFromPath(pathname) {
  const m = pathname.match(OWNER_ID_RE);
  return m ? m[1] : null;
}

export function isCrmBrowserPath(pathname) {
  return OWNER_ID_RE.test(pathname);
}

export function crmBase(ownerId) {
  return `/${ownerId}/crm`;
}

export function crmBranchesPath(ownerId) {
  return `/${ownerId}/crm/branches`;
}

export function crmBranchPath(ownerId, branchId) {
  return `/${ownerId}/crm/${branchId}`;
}

const BRANCH_ID_RE = new RegExp(`^${UUID}$`, 'i');

/** Сегмент филиала в URL после /{ownerId}/crm/ (не «branches»). */
export function parseCrmBranchIdFromPath(pathname, ownerId) {
  if (!ownerId) return null;
  const prefix = `/${ownerId}/crm/`;
  if (!pathname.startsWith(prefix)) return null;
  const seg = pathname.slice(prefix.length).split('/')[0] ?? '';
  if (!seg || seg === 'branches') return null;
  return BRANCH_ID_RE.test(seg) ? seg : null;
}

/** Куда отправить после 401 в CRM (логин с тем же owner в URL). */
export function crmLoginPathFromLocation() {
  const id = parseCrmOwnerIdFromPath(window.location.pathname);
  return id ? crmBase(id) : '/';
}
